module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar-saldo-report-page"
  }, [_c('div', {
    staticClass: "foo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_balance_users_report')))]), _vm._v(" "), _c('p', {
    staticClass: "bar-saldo-report-page__subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_only_non_zero_balances')))]), _vm._v(" "), _c('div', {
    staticClass: "bar-saldo-report-page__toolbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input bar-saldo-report-page__search",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search')
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }, _vm.onFilterInput]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content table-responsive table-full-width bar-saldo-report-page__table-wrap"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.locale.t('label_name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_username')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_email')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_phone')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_bar_balance')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_actions')))])])]), _vm._v(" "), _c('tbody', [(!_vm.loading && _vm.users.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_data')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(user.name) + " " + _vm._s(user.surname))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_username')
      }
    }, [_vm._v(_vm._s(user.username || '/'))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_email')
      }
    }, [_vm._v(_vm._s(user.email || '/'))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_phone')
      }
    }, [_vm._v(_vm._s(user.phone || '/'))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_bar_balance')
      }
    }, [_c('span', {
      staticClass: "users-balance-link",
      class: _vm.getBalanceClass(user.barBalance),
      on: {
        "click": function($event) {
          return _vm.openBalanceHistory(user)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.formatBalanceAmount(user.barBalance)) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticClass: "bar-saldo-report-page__actions-cell",
      attrs: {
        "data-title": _vm.locale.t('label_actions')
      }
    }, [_c('button', {
      staticClass: "new-button bar-saldo-report-page__action-btn",
      on: {
        "click": function($event) {
          return _vm.openBalanceHistory(user)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.locale.t('label_add_subtract')) + "\n          ")])])])
  })], 2)])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "bar-saldo-report-page__loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : _vm._e(), _vm._v(" "), (_vm.showBalanceHistory) ? _c('user-balance-history-modal', {
    attrs: {
      "locale": _vm.locale,
      "selected-balance-user": _vm.selectedBalanceUser,
      "balance-history": _vm.balanceHistory,
      "balance-history-page": _vm.balanceHistoryPage,
      "balance-history-limit": _vm.balanceHistoryLimit,
      "balance-history-total": _vm.balanceHistoryTotal,
      "is-loading-balance-history": _vm.isLoadingBalanceHistory,
      "is-adjusting-balance": _vm.isAdjustingBalance,
      "balance-adjust-amount": _vm.balanceAdjustAmount,
      "balance-adjust-note": _vm.balanceAdjustNote
    },
    on: {
      "close": function($event) {
        return _vm.closeBalanceHistory()
      },
      "load-history": _vm.loadBalanceHistory,
      "submit-adjust": _vm.submitBalanceAdjust,
      "update-amount": function($event) {
        _vm.balanceAdjustAmount = $event
      },
      "update-note": function($event) {
        _vm.balanceAdjustNote = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2581f97b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Report/BarSaldoDebtorsReport.vue
// module id = 739
// module chunks = 0